<template>
  <modal name="delivery-info-modal" height="auto" width="880px" style="margin-top: 40px; z-index: 99999;" :scrollable="true" :shiftY="0.2">
    <div class="close">
      <img class="hover_btn" src="../../assets/icons/close.svg" @click="close()"  alt="">
    </div>
    <div class="modal-form">
      <div class="input-block" v-if="step == 1">
        <loading-container :loading="loading" height="99">
          <span class="order-info">Номер заказа: <b>{{order.id}}</b></span>
          <span class="order-info">Поставщик: <b>{{order.provider ? order.provider.name : ''}}</b></span>
          <span class="order-info">Сумма заказа: <b>{{order.sum}} руб</b></span>
          <span class="order-info">Вес: <b>{{order.weight}} кг</b></span>
          <span class="order-info">Объем: <b>{{order.vol}}</b></span>
          <br>
          <span class="info">Расчет является предварительным и может быть изменен</span>
          <table>
            <tr>
              <th>Перевозчик</th>
              <th>Город отправителя</th>
              <th>Город получателя</th>
              <th>Тип доставки</th>
              <th>Способ доставки</th>
              <th>Срок, дней</th>
              <th>Стоимость, руб</th>
              <th></th>
            </tr>
            <tr v-for="(data, key) in info" :key="key + '-delivery'">
              <td>{{data.company}}</td>
              <td>{{data.send_city}}</td>
              <td>{{data.receiver_city}}</td>
              <td>{{data.delivery_type}}</td>
              <td>{{data.type}}</td>
              <td>{{data.period}}</td>
              <td>{{data.price}}</td>
              <td>
                <app-radio
                    v-model="select_delivery_type"
                    :val="key"
                />
              </td>
            </tr>
          </table>
          <div class="btn">
            <button style="margin-top: 16px; width: 200px;" v-if="order.status == 0 && order.contract && info.length > 0" @click="selectCompany()">Продолжить</button>
            <span class="text-danger text-sm" v-if="select_error">{{ select_error }}</span>
          </div>
        </loading-container>
      </div>
      <div class="input-block" v-if="step == 2">
        <br>
        <h4 v-if="delivery_type == 'до терминала'">Терминал</h4>
        <div class="input-block" v-if="delivery_type == 'до терминала'">
          <app-select :options="terminals" :value="terminal" @input="terminal = $event" name="terminal" v-validate="'required'" label="address" placeholder="Терминал" data-vv-as="Терминал"/>
          <span class="text-danger text-sm">{{ errors.first('terminal') }}</span>
        </div>

        <h4>Плательщик</h4>
        <div class="input-block">
          <app-select :options="payers" :key="key" :value="payer" @input="payer = $event" label="title" v-validate="'required'" name="payer" placeholder="Плательщик" data-vv-as="Плательщик"/>
          <span class="text-danger text-sm">{{ errors.first('payer') }}</span>
        </div>
        <h4>Оплата</h4>
        <div class="input-block">
          <app-select :options="payment_types" :value="payment_type" @input="payment_type = $event" v-validate="'required'" name="payment_type" label="title" data-vv-as="Оплата" placeholder="Оплата"/>
          <span class="text-danger text-sm">{{ errors.first('payment_type') }}</span>
        </div>
        <h4>Получатель</h4>
        <div class="input-block">
          <input v-model="receiver_name" class="receiver_name_input" style="margin-bottom: 4px;" placeholder="ФИО получаетеля" v-validate="'required'" name="receiver_name" data-vv-as="ФИО получателя" >
          <span class="text-danger text-sm">{{ errors.first('receiver_name') }}</span>
        </div>
        <h4>Телефон получателя</h4>
        <div class="input-block">
          <input v-model="receiver_phone" ref="pfil" class="receiver_phone" v-validate="'required'" name="phone" data-vv-as="Телефон получаетеля" placeholder="Телефон получателя" >
          <span class="text-danger text-sm">{{ errors.first('phone') }}</span>
        </div>
        <app-checkbox
            v-model="isset_account"
            v-if="!delline_session && select_delivery_company == 'Деловые линии'"
        >
          Есть аккаунт на "Деловые линии"
        </app-checkbox>
        <div v-if="isset_account && !delline_session && select_delivery_company == 'Деловые линии'">
          <h4>Логин</h4>
          <div class="input-block">
            <input v-model="delline_login" placeholder="Логин" >
          </div>
          <div class="input-block">
            <app-password v-model="delline_password" placeholder="Пароль" />
          </div>
        </div>
        <app-checkbox
            v-model="isset_account"
            v-if="!pec_session && select_delivery_company == 'ПЭК' && false"
        >
          Есть аккаунт в "ПЭК"
        </app-checkbox>
        <div v-if="isset_account && !pec_session && select_delivery_company == 'ПЭК'">
          <h4>Логин</h4>
          <div class="input-block">
            <input v-model="pec_login" placeholder="Логин" >
          </div>
          <h4>Апи ключ</h4>
          <div class="input-block">
            <input v-model="pec_key" placeholder="Ключ" >
          </div>
        </div>
        <div class="btn">
          <button style="margin-top: 16px; width: 200px;" @click="selectTerminal()">Продолжить</button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>

import LoadingContainer from "@/components/loading-container";
import AppRadio from "@/components/app-radio";
import AppCheckbox from "@/components/app-checkbox";
import AppSelect from "@/components/app-select";
import Inputmask from "inputmask";
import AppPassword from "@/components/app-password";

export default {
  name: "delivery-info-modal",
  components: {AppPassword, LoadingContainer, AppRadio, AppSelect, AppCheckbox},
  data: ()=> ({
    info: [],
    order: [],
    address: null,
    select_error: null,
    select_delivery_type: null,
    loading: true,
    step: 1,
    terminal: '',
    terminal_error: '',
    delivery_type: '',
    terminals: [],
    only_tk: '',
    payers: [
      {
        'name': 'sender',
        'title': 'Отправитель'
      },
      {
        'name': 'receiver',
        'title': 'Получатель'
      }
    ],
    payer: '',
    payment_types: [
      {
        'name': 'cash',
        'title': 'Наличные'
      },
      {
        'name': 'noncash',
        'title': 'Безналичные'
      }
    ],
    payment_type: '',
    receiver_name: '',
    receiver_phone: '',
    isset_account: 0,
    delline_login: '',
    delline_password: '',
    pec_login: '',
    pec_key: '',
    delline_session: false,
    pec_session: false,
    key: 1,
    select_delivery_company: ''
  }),
  methods: {
    open(address, order, delline_session, pec_session, tk){
      if (address) {
        this.info = [];
        this.terminal = '';
        this.address = address.id;
        if (tk) {
          this.only_tk = tk;
        } else {
          this.only_tk = '';
        }
        this.order = order;
        if (order.purchaser_logist) {
          this.receiver_name = order.purchaser_logist.surname + ' ' + order.purchaser_logist.name;
          this.receiver_phone = order.purchaser_logist.phone;
        }
        if (this.order.provider_id == 53) {
          this.payers = [
            {
              'name': 'receiver',
              'title': 'Получатель'
            }
          ];
          this.key++;
        }
        this.delline_session = delline_session;
        this.pec_session = pec_session;
        this.loading = true;
        this.getDeliveryCalculator();
        this.step = 1;
        this.terminals = [];
        this.$modal.show('delivery-info-modal');
      }
    },
    clear(){
      this.id = '';
    },
    close() {
      this.$emit('select_delivery_company', '');
      this.$emit('select_delivery_type', '');
      this.$emit('select_terminal', '');
      this.$modal.hide('delivery-info-modal');
    },
    selectCompany() {
      this.select_error = '';

      if (this.select_delivery_type == null) {
        this.select_error = 'Выберите метод доставки';
      } else {
        this.select_delivery_company = this.info[this.select_delivery_type].company;
        this.$emit('select_delivery_company', this.info[this.select_delivery_type].company);
        this.$emit('select_delivery_type', this.info[this.select_delivery_type].type);
        this.$emit('select_delivery_type2', this.info[this.select_delivery_type].delivery_type);
        this.delivery_type = this.info[this.select_delivery_type].delivery_type;
        this.terminals = this.info[this.select_delivery_type].terminals;
        this.step = 2;
        this.$nextTick(() => {
          let im = new Inputmask("+7 (999) 999 99 99");
          im.mask(this.$refs.pfil);
        });
        /*this.$emit('continue', '');
        this.$modal.hide('delivery-info-modal');*/
      }

    },
    selectTerminal() {
      /*this.terminal_error = '';

      if (!this.terminal) {
        this.terminal_error = 'Выберите терминал';
      } else {*/
      this.$validator.validateAll()
          .then(success=>{
            if(success){
              this.$emit('select_terminal', this.terminal);
              this.$emit('receiver_info', {
                'payer': this.payer ? this.payer.name : '',
                'payment_type': this.payment_type ? this.payment_type.name : '',
                'receiver_name': this.receiver_name,
                'receiver_phone': this.receiver_phone,
                'delline_login': this.delline_login,
                'delline_password': this.delline_password,
                'pec_login': this.pec_login,
                'pec_key': this.pec_key
              });
              this.$emit('continue', '');
              this.$modal.hide('delivery-info-modal');
            }
          })
     /* }*/

    },
    getDeliveryCalculator() {
      if (localStorage.getItem('token')) {
        this.$http.post('/get-delivery-calculator-info', {
          token: localStorage.getItem('token'),
          address: this.address,
          order: this.order.id
        }).then(({data}) => {
          if (data.info) {
            if (!this.only_tk) {
              this.info = data.info;
            } else {
              for (let key in data.info) {
                if (data.info[key].company == this.only_tk) {
                  this.info.push(data.info[key]);
                }
              }
            }
          }
        })
        .catch((error) => {
            console.log(error)
        })
        .finally(()=> {this.loading = false;})
      }
    }
  }
}
</script>

<style scoped lang="scss">

.progress-bar-container {
  width: 140px;
  margin: 0px auto;
}

.order-info {
  font-size: 14px;
  margin-right: 10px;
}

.info {
  font-size: 13px;
}

.btn{
  width: 100%;
  padding: 0;
  button{
    width: 100%;
    height: 50px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    background: #2CB181;
    border-radius: 4px;
    border: none;
  }
}
.modal-form {
  padding: 30px;
}
.input-block {
  margin-bottom: 15px;
}
h4{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0 0 5px 1px;
  &.add{
    display: flex;
    justify-content: space-between;
    a{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      text-decoration-line: underline;
      color: #7A818F;
    }
  }
}
input{
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding-left: 10px;
  width: 100%;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  &.about{
    height: 117px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}
</style>
